import { render, staticRenderFns } from "./SpecializationsTable.vue?vue&type=template&id=7f7d0d3a&"
import script from "./SpecializationsTable.vue?vue&type=script&lang=js&"
export * from "./SpecializationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports